import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function StatusImpugnacaoPage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Status de Impugnação"
      description="Gerencie os status de impugnação."
      tableName="status_impugnacao_v2"
      columns={columns}
      fields={fields}
    />
  );
}